export default __webpack_public_path__ + "static/media/sport5.8452d1a9.svg";